import { useEffect, useState } from "react";

/** The room link with a copy button and a QR code (generated locally, never sent anywhere). */
export function InviteCard({ link }: { link: string }) {
  const [qr, setQr] = useState<string>();
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    let cancelled = false;
    // The QR encoder loads only when someone shares.
    void import("qrcode")
      .then(({ default: QRCode }) =>
        QRCode.toDataURL(link, { margin: 1, width: 160, errorCorrectionLevel: "M" }),
      )
      .then((url) => {
        if (!cancelled) setQr(url);
      });
    return () => {
      cancelled = true;
    };
  }, [link]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2_000);
    } catch {
      // Clipboard blocked: the link is selectable below.
    }
  };

  return (
    <section className="invite" aria-label="Invite">
      <h3 className="panel-subheading">Invite</h3>
      <p className="panel-hint">
        Anyone with this link can join and edit. Share it like a password.
      </p>
      <p className="panel-hint invite-how">
        You'll connect directly over WebRTC. The public Nostr relays only help you find each other
        and never see your code.
      </p>
      <div className="invite-row">
        <input
          className="invite-link"
          aria-label="Room link"
          readOnly
          value={link}
          onFocus={(e) => e.target.select()}
        />
        <button type="button" className="primary" onClick={() => void copy()}>
          {copied ? "Copied!" : "Copy link"}
        </button>
      </div>
      {qr && (
        <details className="invite-qr-toggle">
          <summary>Show QR code</summary>
          <img
            className="invite-qr"
            src={qr}
            alt="QR code for the room link"
            width={160}
            height={160}
          />
        </details>
      )}
    </section>
  );
}
